import { useState } from 'react';
import { Container, TextField, Button, Typography, Alert } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { apiFetch } from '../api';
export default function PasswordResetPage() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await apiFetch('/api/auth/password-reset/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (!response.ok) {
        throw new Error('Failed to send reset email');
      }
      setMessage('Check your email for reset instructions.');
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <Container sx={{ py: 4 }} maxWidth="sm">
      <Typography variant="h4" component="h1" gutterBottom>
        Password Reset
      </Typography>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {message}
        </Alert>
      )}
      <form onSubmit={handleSubmit}>
        <TextField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          fullWidth
          margin="normal"
          required
        />
        <Button variant="contained" type="submit" sx={{ mt: 2 }}>
          Send Reset Email
        </Button>
      </form>
      <Button sx={{ mt: 2 }} component={RouterLink} to="/login">
        Back to login
      </Button>
    </Container>
  );
}
